export const getAddressKey = (address) => {
  if (!address) return "";
  return `${address.id ?? ""}-${address.latitude ?? address.lat ?? ""}-${address.longitude ?? address.lng ?? ""}-${address.name ?? ""}`;
};

// Saved subroutes use their id as a position, rather than an address identifier.
export const getSavedRouteKey = (address) => {
  if (!address) return "";
  return getAddressKey({
    ...address,
    id: undefined,
    name: String(address.name ?? "").trim().toUpperCase(),
  });
};

export const getAddressLabel = (address) => {
  if (!address) return "";
  return `${address.name ?? ""}${address.url_address ? ` ${address.url_address}` : ""}`;
};

export const normalizeAddress = (address) => {
  if (!address) return null;
  return {
    ...address,
    latitude: address.latitude ?? address.lat,
    longitude: address.longitude ?? address.lng,
  };
};

export const moveItem = (items, fromIndex, toIndex) => {
  const nextItems = [...items];
  const [item] = nextItems.splice(fromIndex, 1);
  nextItems.splice(toIndex, 0, item);
  return nextItems;
};

export const hasCoordinates = (address) => {
  const normalizedAddress = normalizeAddress(address);

  return (
    normalizedAddress?.latitude !== null &&
    normalizedAddress?.latitude !== undefined &&
    normalizedAddress?.longitude !== null &&
    normalizedAddress?.longitude !== undefined &&
    !Number.isNaN(Number(normalizedAddress.latitude)) &&
    !Number.isNaN(Number(normalizedAddress.longitude))
  );
};

export const toLatLngLiteral = (address) => ({
  lat: Number(normalizeAddress(address)?.latitude),
  lng: Number(normalizeAddress(address)?.longitude),
});
